import posthog from 'posthog-js';

const initPosthog = tenantApp => {
  const email = tenantApp?.externalInfo?.email || tenantApp?.optEmail || '';
  posthog.identify(email, {
    email
  });
};

export { initPosthog };
